import React from 'react';
import $ from 'jquery';
import ContestLanding from '../common/ContestLanding';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion';
// 'Fancy' theme - boilerplate styles for all components, as seen on our demo:
import 'react-accessible-accordion/dist/fancy-example.css';
import HmEventRegistry from '../../model/HmEventRegistry';
import HmAjax from '../../util/HmAjax';

class ContestFaq extends ContestLanding {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded : false
    };

    this.data = {};

    this.getQATemplate = this.getQATemplate.bind(this);
    this.getParentTemplate = this.getParentTemplate.bind(this);

    this.setChild(this,"CONTEST");
  }

  componentDidMount(){
   super.componentDidMount();
   
   this.loadData();
 }

 loadData(){
  let me = this;
  let success = (resp) =>{
    me.data = resp;
    me.setState({dataLoaded: true});
 }

 let failure = (err) =>{
  console.error("error while getting faq json", err);
}

new HmAjax(this.getUriFor("GET_CONTEST_FAQ_JSON").replace("{#contestId}",this.getSelectedContestGroup())).get(success, failure);
}

handleChange(id){

  console.log("Accordian changed ",id);
  if($('#matericon'+id).hasClass("minus")){
    $('#matericon'+id).removeClass("minus")
    $('#matericon'+id).addClass("plus")
    $('#matericon'+id).html('<i class="material-icons">add</i>');
  }else{
    $('#matericon'+id).removeClass("plus")
    $('#matericon'+id).addClass("minus")
    $('#matericon'+id).html('<i class="material-icons">remove</i>');
  }
}

getQATemplate(qStr, aStr, idx=null){
  return(
    <div className="faqcnt"> 
    <h3 className="blustr">{(idx ? idx : "" ) + this.reactHtmlParser(qStr)}</h3>
    <div>
    {this.reactHtmlParser(aStr)}
    </div>
    </div>
    )
  }

getParentTemplate(titleTxt, quesArr, mainIdx){
    const me = this;
    return(
    <AccordionItem expanded={false}>
    <AccordionItemTitle>
    <div>
    <h3>{((mainIdx) ? ((mainIdx) + ". ") : "" )  + titleTxt}<span id={"matericon"+mainIdx}><i class="material-icons">add</i></span></h3>
    </div>
    </AccordionItemTitle>
    <AccordionItemBody>
    {quesArr.map((elem,idx) => {
      try{
        let subIdx = (mainIdx ? mainIdx+"." : "") + (idx + 1) + ") ";
        return me.getQATemplate(elem[0],elem[1], subIdx);
      }catch(e){        
        console.error(e);
      }      
    })}
    </AccordionItemBody>
    </AccordionItem>
    )
  }

render() {
  const me = this;
  if(this.state.dataLoaded){
    return super.render(
      <div className="HomeComponent" id="Contestfaq">
      <h4>{me.rb("label.faq")}</h4>
      <div>
      <div className="faqaccord">

      {(() => {
        return Object.keys(me.data).map((elem, idx) =>{
          let mainIdx = idx + 1;
          return (
          <Accordion onChange={me.handleChange.bind(this,mainIdx)}>
           {me.getParentTemplate(elem, me.data[elem], mainIdx)}
          </Accordion>)
        })
      })()}     

      </div> 
      </div>
      </div>
      )
    }else{
      return super.render(
      <div> {this.showLoader()} </div>
      )
    }
  }  
}

export default ContestFaq;


// WEBPACK FOOTER //
// ./src/views/contest/ContestFaq.js